import React from 'react'
import LucideIcon from '../lucideIcon'

export default function WordCount(props) {
  return (
    <div className="counting">
       <LucideIcon name={props.icon} style={{margin:"10px"}}/>
       <div className="innercounting">
       <h3 style={{fontSize:"1.3rem"}}>{props.value}</h3>
       <p>{props.name}</p>
       </div>
    </div>
  )
}
